// extracted by mini-css-extract-plugin
export var resourcesWrapper = "ResourcesHeadingSearch-module--resources-wrapper--3IhYR";
export var headingWrapper = "ResourcesHeadingSearch-module--heading-wrapper--3pMtd";